<template>
  <div class="container py45">
    <div :style="fetching === true ? 'height: 210px' : ''">
      <template
        v-if="fetching"
        style="height: 530px"
      >
        <div class="fetching">
          <div class="gooey">
            <span class="dot" />
            <div class="dots">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col">
          <div class="row">
            <div class="col-md-12 mb30">
              <h1 class="block-title">
                {{ $t('label.viewLoanDetail') }}
              </h1>
            </div>
          </div>
          <ul
            class="nav nav-pills mb-3"
            id="pills-tab"
            role="tablist"
          >
            <li class="nav-item">
              <a
                class="nav-link active"
                id="pills-repayment-tab"
                data-toggle="pill"
                href="#pills-repayment"
                role="tab"
                aria-controls="pills-repayment"
                @click="getRepayment"
                aria-selected="true"
              >
                {{ $t('label.repayment') }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="pills-profile-tab"
                data-toggle="pill"
                href="#pills-profile"
                role="tab"
                aria-controls="pills-profile"
                @click="getSchedule"
                aria-selected="false"
              >
                {{ $t('label.loanSchedule') }}
              </a>
            </li>
          </ul>
          <div
            class="tab-content"
            id="pills-tabContent"
          >
            <div
              class="tab-pane fade show active"
              id="pills-repayment"
              role="tabpanel"
              aria-labelledby="pills-repayment-tab"
            >
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('label.collectionDate') }}
                      </th>
                      <th scope="col">
                        {{ $t('label.collectedBy') }}
                      </th>
                      <th scope="col">
                        {{ $t('label.method') }}
                      </th>
                      <th scope="col">
                        {{ $t('label.amount') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="inProgress">
                      <tr>
                        <td
                          colspan="12"
                          class="text-center"
                        >
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span class="sr-only">{{ $t('label.loading') }}</span>
                          </div>
                          {{ $t('label.loading') }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <template v-if="repayments.length > 0">
                        <tr
                          v-for="(item, key) in repayments"
                          :key="key"
                        >
                          <td>{{ item.repayment_collected_date }}</td>
                          <td>{{ collector[item.collector_id] }}</td>
                          <td>{{ repayment_method[item.loan_repayment_method_id] }}</td>
                          <td>{{ item.repayment_amount }} USD</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            colspan="12"
                            class="text-center"
                          >
                            <figure>
                              <img
                                :src="'/img/icons/transfer_money.svg'"
                                alt="image"
                                class="mt-2"
                                style="width: 25%"
                              >
                              <figcaption class="mt-3">
                                {{ $t('label.noData') }}
                              </figcaption>
                            </figure>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{{ $t('label.date') }}</th>
                      <th>{{ $t('label.description') }}</th>
                      <th>{{ $t('label.principal') }}</th>
                      <th>{{ $t('label.interest') }}</th>
                      <th>{{ $t('label.fees') }}</th>
                      <th>{{ $t('label.penalty') }}</th>
                      <th>{{ $t('label.due') }}</th>
                      <th>{{ $t('label.paid') }}</th>
                      <th>{{ $t('label.pendingDue') }}</th>
                      <th>{{ $t('label.totalDue') }}</th>
                      <th>{{ $t('label.principalBalance') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="inProgress">
                      <tr>
                        <td
                          colspan="12"
                          class="text-center"
                        >
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span class="sr-only">{{ $t('label.loading') }}</span>
                          </div>
                          {{ $t('label.loading') }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <template v-if="loanSchedules.length > 0">
                        <tr
                          v-for="(item, key) in loanSchedules"
                          :key="key"
                        >
                          <td>{{ item['#'] }}</td>
                          <td>{{ item.Date }}</td>
                          <td v-html="item['Description']" />
                          <td>{{ item.Principal }}</td>
                          <td>{{ item.Interest }}</td>
                          <td>{{ item.Fees }}</td>
                          <td>{{ item.Penalty }}</td>
                          <td>{{ item.Due }}</td>
                          <td>{{ item.Paid }}</td>
                          <td>{{ item['Pending Due'] }}</td>
                          <td>{{ item['Total Due'] }}</td>
                          <td>{{ item['Principal Due'] }}</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            colspan="12"
                            class="text-center"
                          >
                            <figure>
                              <img
                                :src="'/img/icons/transfer_money.svg'"
                                alt="image"
                                class="mt-2"
                                style="width: 25%"
                              >
                              <figcaption class="mt-3">
                                {{ $t('label.noData') }}
                              </figcaption>
                            </figure>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-12 no-padding">
            <div class="row">
              <div class="col-md-12">
                <button
                  class="btn btn-secondary"
                  @click="$router.push({name: 'profile', params: {activeTabs: 'history'}})"
                >
                  {{ $t('global.btn.back') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoanDetail',
  metaInfo: {
    title: 'Loan Detail',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Loan Detail' }
    ]
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing,vue/require-default-prop
    loan_id: null
  },
  data () {
    return {
      inProgress: false,
      fetching: true,
      repayments: [],
      repayment_page: {
        total_pages: 0,
        current_page: 1,
        per_page: 10,
        total_records: 0
      },
      loanSchedules: [],
      loan_schedule_page: {
        total_pages: 0,
        current_page: 1,
        per_page: 10,
        total_records: 0
      },
      repayment_method: null,
      collector: null
    }
  },
  methods: {
    getRepayment () {
      if (this.repayments.length <= 0) {
        this.inProgress = true
        this.$axios.post(this.$base_api + '/api/v1/frontend/get-repayment-by-loan', {
          loan_id: this.loan_id
        }).then((response) => {
          if (response.data.code === 1) {
            this.repayments = response.data.data
            this.repayment_page = response.data
          }
        }).finally(() => {
          this.inProgress = false
          this.fetching = false
        })
      }
    },
    getSchedule () {
      if (this.loanSchedules.length <= 0) {
        this.inProgress = true
        this.$axios.post(this.$base_api + '/api/v1/frontend/get-schedule-by-loan', {
          loan_id: this.loan_id
        }).then((response) => {
          if (response.data.code === 1) {
            this.loanSchedules = response.data.data
          }
        }).finally(() => {
          this.inProgress = false
        })
      }
    },
    getPaymentMethod () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/loan-disk-option/get-repayment-option')
        .then((response) => {
          if (response.data.code === 1) {
            const obj = {}
            const arr = response.data.data
            for (var i = 0; i < arr.length; i++) {
              obj[arr[i].loan_repayment_method_id] = arr[i].loan_repayment_method_name
            }
            this.repayment_method = obj
          }
        })
    },
    getCollector () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/loan-disk-option/get-collector-option')
        .then((response) => {
          if (response.data.code === 1) {
            const obj = {}
            const arr = response.data.data
            for (var i = 0; i < arr.length; i++) {
              obj[arr[i].collector_id] = arr[i].collector_name
            }
            this.collector = obj
          }
        })
    }
  },
  mounted () {
    if (this.loan_id) {
      this.getPaymentMethod()
      this.getCollector()
      this.getRepayment()
    }
  }
}
</script>

<style scoped>
  @import "../../assets/styles/fecthing.css";

  table tbody tr:last-child {
    border-bottom: 1px solid #dee2e6;
  }

  .nav-pills .nav-link.active {
    background-color: var(--primary) !important;
  }

  a {
    color: var(--primary);
  }

  .table thead th,
  .table tbody td {
    vertical-align: middle !important;
  }
</style>
